(function () {
  console.log('[cart-slide] loaded');

  const panel = document.getElementById('cart-slide-panel');
  if (!panel) return;

  const titleEl = panel.querySelector('.cart-slide-title');
  const priceEl = panel.querySelector('.cart-slide-price');
  const imageEl = panel.querySelector('.cart-slide-image');
  const closeBtn = panel.querySelector('.cart-slide-close');

  let autoCloseTimer = null;

  function openPanel() {
    panel.classList.add('active');
    panel.setAttribute('aria-hidden', 'false');

    if (autoCloseTimer) clearTimeout(autoCloseTimer);

    autoCloseTimer = setTimeout(() => {
      closePanel();
    }, 3000);
  }

  function closePanel() {
    panel.classList.remove('active');
    panel.setAttribute('aria-hidden', 'true');
  }

  function renderItem(item) {
    console.log('[cart-slide] renderItem item =', item);

    titleEl.textContent = item.product_title || item.title || '';
    priceEl.textContent = `$${((item.price || 0) / 100).toLocaleString()}`;

    const image =
      item.image ||
      item.featured_image?.url ||
      item.featured_image ||
      '';

    console.log('[cart-slide] resolved image =', image);

    if (image) {
      imageEl.src = image;
      imageEl.alt = item.product_title || item.title || '';
    }
  }

  closeBtn?.addEventListener('click', closePanel);

  console.log('[cart-slide] eventBus:', window.eventBus);

  const bus =
    (typeof eventBus !== 'undefined' && eventBus) ||
    (typeof window !== 'undefined' && window.eventBus);

  console.log('[cart-slide] resolved bus =', bus);

  if (bus?.on) {
    bus.on('cart:added', (payload) => {
      console.log('[cart-slide] cart:added received', payload);

      const item = payload?.item;
      if (!item) {
        console.log('[cart-slide] no item in payload');
        return;
      }

      renderItem(item);
      openPanel();
    });
  } else {
    console.log('[cart-slide] eventBus not available');
  }
})();